module.exports = __webpack_public_path__ + "static/media/plan-peculioseguro.7f26bb7b.png";